import { LoadingContainer } from 'components/loadingContainer'
import { EventListUser } from 'features/user/Event'
import { useEventsUser } from 'hooks/user/useEvents'

export const EventListUserPage = () => {
    const { data, isLoading, error } = useEventsUser()

    return (
        <LoadingContainer isLoading={isLoading} error={error}>
            {data && <EventListUser data={data} />}
        </LoadingContainer>
    )
}
